<div class="stepper" data-cy="stepper" data-variant="variant1">
  <div class="stepper-keys">
    <div class="earn">
      {{ config().body.progressbar.earnLabel }}
    </div>
    <div class="spend">
      {{ config().body.progressbar.spendLabel }}
    </div>
  </div>
  <div class="progress-bar-container">
    <div class="progress-bar"></div>
    <div
      data-cy="progress-bar"
      class="progress-bar-value"
      [style.width]="challenge() | progressWidth: limitsPerNbSteps"
    ></div>
  </div>
  <div
    class="steps"
    [style.left]="
      challenge().targets.length === 1
        ? '155px'
        : challenge().targets.length === 2
          ? '40px'
          : '8px'
    "
  >
    @for (item of challenge().targets; track $index; let i = $index) {
      @let stepStatus = challenge() | stepStatus: i;

      <div
        class="stepper-item {{ stepStatus }}"
        [style.marginRight]="
          challenge().targets.length === 2 && i === 0 ? '40px' : 0
        "
      >
        <div
          class="step-reward {{ stepStatus }}"
          [style]="{
            color: config().body.rewards.color,
            fontFamily: config().body.rewards.fontFamily,
          }"
          [innerHTML]="
            challenge().steps[i].reward | formatReward: '12px' | safe
          "
        ></div>
        <div class="step-progressbar">
          <div class="step-circle {{ stepStatus }}" data-cy="step_reached">
            @if (stepStatus === StepStatus.REACHED) {
              <img
                alt=""
                class="responsive-width"
                data-cy="active_step_img"
                [src]="config().body.progressbar.pictureStageReached"
              />
            }
          </div>
        </div>
        <div
          class="step-target {{ stepStatus }}"
          [style]="{
            color: config().body.targets.color,
            fontFamily: config().body.targets.fontFamily,
          }"
          [innerHTML]="item | formatAmount: 'currency' : 0 | safe"
        ></div>
      </div>
    }
  </div>
</div>
